import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/LigasDeportivas/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/LigasDeportivas/web/src/app/[locale]/(private)/PrivateLayoutClient.tsx");
